const Subscription = () => {
  const standardTemplate = `<div class="bold-ro__product bold-ro__product-id-{{product_id}}">
      <div class="main-btn-wrapper bold-ro__radio-div bold-ro__recurring-div {{#subscription_checked}}bold-ro__bold-active{{/subscription_checked}} bold-ro__sub">
          <label for="once-off-button-{{product_id}}" class="button full-width secondary bold-ro__recurring-lbl">
          {{#recurring_mode.mixed}}
              <input id="once-off-button-{{product_id}}" value="2" name="bold-ro__selector_radio_button" data-bold-recurring
                  class="bold-ro__mixed-radio-btn bold-ro__subscribe-radio-btn"
                  {{^subscription_only}}type="radio"{{/subscription_only}}
                  {{#subscription_only}}type="hidden"{{/subscription_only}}
                  {{#subscription_checked}}checked=""{{/subscription_checked}}>
          {{/recurring_mode.mixed}}
          {{#recurring_mode.single_product}}
              <input value="1" name="bold-ro__selector_radio_button" data-bold-recurring
                  class="bold-ro__recurring-radio-btn bold-ro__subscribe-radio-btn"
                  {{^subscription_only}}type="radio"{{/subscription_only}}
                  {{#subscription_only}}type="hidden"{{/subscription_only}}
                  {{#subscription_checked}}checked=""{{/subscription_checked}}>
          {{/recurring_mode.single_product}}

          <span class="bold-ro__recurring-text {{#subscription_only}}bold-ro__subscription-only{{/subscription_only}}">
              {{#conversion}}
                  {{#merge_conversion_discount_percent}}
                    {{#translate}}{{conversion.type_translation}}{{/translate}}
                  {{/merge_conversion_discount_percent}}
              {{/conversion}}

              {{#standard}}
                  {{^is_prepaid_only}}
                      {{#translate}}widget_repenish{{/translate}}{{#merge_initial_discount}}{{#translate}}{{standard.type_translation}}{{/translate}}{{/merge_initial_discount}}
                  {{/is_prepaid_only}}
                  {{#is_prepaid_only}}
                      {{#merge_prepaid}}{{#translate}}prepay_for_your_subscription{{/translate}}<span class="bold-ro__prepaid-discount-text">{{#translate}}discount{{/translate}}</span>{{/merge_prepaid}}
                  {{/is_prepaid_only}}
              {{/standard}}
          </span>
          </label>
          {{#details_tooltip.location.inline}}{{#details_tooltip.enabled}}<span class="bold-ro__see-details"><a href="javascript:;" class="bold-ro__detail-tooltip">{{#translate}}see_details{{/translate}}</a></span>{{/details_tooltip.enabled}}{{/details_tooltip.location.inline}}
          <div class="pdp_subscription-wrap">
            <div class="bold-ro__frequency-div">
                <div class="bold-ro__frequency-label">
                    {{#conversion}}
                        {{> convertibleTable}}
                    {{/conversion}}

                    {{^has_billing_plan}}
                        {{^fixed_interval}}
                            {{#frequency_too_large}}
                                {{> customFrequencyInterval}}
                            {{/frequency_too_large}}
                            {{^frequency_too_large}}
                                {{#conversion}}
                                    {{> selectableFrequencyInterval}}
                                {{/conversion}}
                                {{^conversion}}
                                    {{> standardFrequencyInterval}}
                                {{/conversion}}
                            {{/frequency_too_large}}
                        {{/fixed_interval}}

                        {{#fixed_interval}}
                            <span class="bold-ro__fixed-frequency-text" {{^subscription_checked}} style="display:none;" {{/subscription_checked}}>{{#translate}}order_will_ship_every{{/translate}} {{#merge_interval_number}}[interval_number]{{/merge_interval_number}} {{#merge_interval}}[interval]{{/merge_interval}}</span>
                            {{> fixedFrequencyInterval}}
                        {{/fixed_interval}}
                    {{/has_billing_plan}}

                    <input name="group_id" class="bold-ro__group-id" type="hidden" value="{{group_id}}"/>
                    <input type="hidden" class="bold-ro__discounted-price" value="{{discount_price}}"/>
                    <input type="hidden" class="bold-ro__discount-percentage" value="{{group_discount}}"/>
                    <input type="hidden" class="bold-ro__unformatted-price" value="{{unformatted_discount_price}}"/>
                    <input type="hidden" name="{{csrf_token_name}}" value="{{csrf_token}}"/>

                    <input type="hidden" name="quantities[]" value="">
                    <input type="hidden" name="product_id[]" value="">
                    <input type="hidden" name="variant_id[]" value="">
                    <input type="hidden" name="note" value="">

                    {{#secondary_discount}}
                        {{> secondaryDiscount }}
                    {{/secondary_discount}}

                    {{#has_billing_plan}}
                        {{#fixed_interval}}
                            {{> fixedFrequencyInterval}}
                        {{/fixed_interval}}
                        {{^fixed_interval}}
                            {{#frequency_type}}
                                <input type="hidden" name="frequency_type" class="bold-ro__frequency-type" value="{{frequency_type_id}}">
                                <input name="frequency_type_text" class="bold-ro__frequency-type-text" type="hidden" value="{{#translate}}{{frequency_type_translation}}{{/translate}}">
                            {{/frequency_type}}
                        {{/fixed_interval}}
                        {{> billingPlan}}
                    {{/has_billing_plan}}

                    {{#limited_subscription}}
                        {{> limitedLength}}
                    {{/limited_subscription}}

                    {{#prepaid}}
                        {{> prepaid}}
                    {{/prepaid}}
                </div>
            </div>
            {{^subscription_only}}
                {{> oneTimePurchase}}
            {{/subscription_only}}
          </div>
      </div>
      {{#details_tooltip.location.bottom}}{{#details_tooltip.enabled}}<span class="bold-ro__see-details"><a href="javascript:;" class="bold-ro__detail-tooltip">{{#translate}}see_details{{/translate}}</a></span>{{/details_tooltip.enabled}}{{/details_tooltip.location.bottom}}
    </div>`;

  const oneTimePurchaseTemplate = `<div class="bold-ro__radio-div bold-ro__one-time-div {{^subscription_checked}}bold-ro__bold-active{{/subscription_checked}}">
      <label for="one-time-input-{{product_id}}" class="bold-ro__recurring-lbl">
          <span class="bold-ro__one-time-purchase">
          {{#conversion}}
              {{#merge_one_time_price}}{{#translate}}one_time_purchase_convertible{{/translate}}{{/merge_one_time_price}}
          {{/conversion}}
          {{#standard}}
              {{#merge_one_time_price}}{{#translate}}cancel{{/translate}}{{/merge_one_time_price}}
          {{/standard}}
          </span>
          <input id="one-time-input-{{product_id}}"  type="radio" value="0" name="bold-ro__selector_radio_button"
              class="bold-ro__one-time-radio-btn"
              {{^subscription_checked}}checked=""{{/subscription_checked}}>
      </label>
    </div>
  `;


  const standardFrequencyIntervalTemplate = `<div class="bold-ro__order-interval-container" {{^subscription_checked}} style="display:none;" {{/subscription_checked}}>
        <figcaption class="bold-ro__order-interval-lbl">{{#translate}}deliver_every{{/translate}}</figcaption>
        <div class="pdp_select-wrapper">
          <div class="select-container">
            <select class="bold-ro__frequency-num" name="frequency_num">
                {{#frequency_num}}
                    <option data-frequency-num="{{frequency_num_id}}" value="{{frequency_num_id}}">{{frequency_num_id}}</option>
                {{/frequency_num}}
            </select>
          </div>
          <div class="select-container">
            <select name="frequency_type" class="bold-ro__frequency-type bold-ro__order-interval">
                {{#frequency_type}}
                    <option data-frequency-type="{{frequency_type_id}}" data-frequency-type-text="{{#translate}}{{frequency_type_translation}}{{/translate}}" value="{{frequency_type_id}}">{{#translate}}{{frequency_type_translation}}{{/translate}}</option>
                {{/frequency_type}}
            </select>
          </div>
        </div>
        {{#shipping_schedule_hover_enable}}
    <a href="javascript:;" class="bold-ro__shipping-tooltip">{{#translate}}shipping_schedule{{/translate}}</a>
        {{/shipping_schedule_hover_enable}}
    </div>
    <input name="frequency_type_text" class="bold-ro__frequency-type-text" type="hidden" value="">
  `


  BOLD.recurring_orders.app.ee.on('before_widget_loaded', function(data) {
    BOLD.recurring_orders.setTemplate('oneTimePurchase', oneTimePurchaseTemplate, true);
    BOLD.recurring_orders.setTemplate('standardFrequencyInterval', standardFrequencyIntervalTemplate, true);
    BOLD.recurring_orders.setTemplate('standard', standardTemplate, true);
  });
}

export default Subscription;